import { useEffect, useRef, useState } from 'react';
import { useWatch } from 'react-hook-form';

export const useWatchTableRowCountDebounced = (
  tableName: string,
  timeout = 500
) => {
  const tableRowLength: number = useWatch({
    name: `${tableName}.length`,
  });
  const isMounted = useRef(false);
  const [tableRowCount, setTableRowCount] = useState<number | undefined>(
    undefined
  );

  useEffect(() => {
    const timerId = setTimeout(() => {
      if (!isMounted.current) {
        isMounted.current = true;
        return;
      }
      if (typeof tableRowLength !== 'number') {
        throw new Error(
          `Expecting type of "tableRowLength" to be "number" but got "${typeof tableRowLength}"`
        );
      }
      setTableRowCount(tableRowLength);
    }, timeout);

    return () => {
      clearTimeout(timerId);
    };
  }, [tableRowLength, timeout]);

  return tableRowCount;
};
